
import detailDefault from '../../detailDefault';
export default class detailacm_CampaignsAction extends detailDefault {
    load(sAction, data) {
        const val = sAction.dataGet(data.prefix+'/fields/type/value');
        this.updateFieldsVisibility(sAction, data, val);
    }
    update(sAction, data) {
        // pokud je vybran v ciselniku Typ "Skoleni"
        if (data.field === 'type') {
            this.updateFieldsVisibility(sAction, data, data.value);
        }
    }

    // fce skryva/odkryva fieldy podle stavu checkboxu
    updateFieldsVisibility(sAction, data, type) {
        sAction.dataSet(data.prefix+'/fields/date_training/def/visible', false);
        sAction.dataSet(data.prefix+'/fields/subject/def/visible', false);
        sAction.dataSet(data.prefix+'/fields/headline/def/visible', false);
        sAction.dataSet(data.prefix+'/fields/button_label/def/visible', false);
        sAction.dataSet(data.prefix+'/fields/pic/def/visible', true);
        sAction.dataSet(data.prefix+'/fields/ord/def/visible', true);
        sAction.dataSet(data.prefix+'/fields/url/def/visible', true);

        switch (type) {
            case 'Training':
                sAction.dataSet(data.prefix+'/fields/date_training/def/visible', true);
                break;
            case 'carousel':
                sAction.dataSet(data.prefix+'/fields/headline/def/visible', true);
                sAction.dataSet(data.prefix+'/fields/button_label/def/visible', true);
                sAction.dataSet(data.prefix+'/fields/pic/def/visible', false);
                break;
            case 'carousel_login':
                sAction.dataSet(data.prefix+'/fields/subject/def/visible', true);
                sAction.dataSet(data.prefix+'/fields/headline/def/visible', true);
                sAction.dataSet(data.prefix+'/fields/button_label/def/visible', true);
                sAction.dataSet(data.prefix+'/fields/pic/def/visible', false);
                break;
            case 'dashboard_widget_background':
                sAction.dataSet(data.prefix+'/fields/ord/def/visible', false);
                sAction.dataSet(data.prefix+'/fields/url/def/visible', false);
                sAction.dataSet(data.prefix+'/fields/pic/def/visible', true);
                break;
        }
    }
}
